export default {
  "content": "<path d=\"M22 19.5h-2v-15h2v15zM6 10.057l1.919-1.37 1.162 1.627-2.362 1.685 2.362 1.688-1.162 1.627-1.92-1.372V16H4v-2.058l-1.918 1.371-1.162-1.627L3.279 12l-2.36-1.686L2.08 8.688 4 10.057V8h2v2.057zM15 10.057l1.919-1.37 1.162 1.627-2.362 1.685 2.362 1.688-1.162 1.627-1.92-1.372V16h-2v-2.058l-1.918 1.371-1.162-1.627L12.279 12l-2.36-1.686 1.162-1.626L13 10.057V8h2v2.057z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};